import { Component, h, State, EventEmitter, Event, getAssetPath } from '@stencil/core';
import { isometrikLogo } from '../assets/svg/IsometrikLogo';
import { CHAT_CREDS, isometrikFlutterAppSecrets } from '../constants/chat-creds';

const onboardingImagePath = getAssetPath('../assets/images/onboarding.webp');

@Component({
  tag: 'signup-page',
  shadow: true,
  styles: `
    :host {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100dvh;
      background: var(--bg-primary-color);
      font-family: 'Simpli Norm', sans-serif;
    }

    .signup-container {
      padding: 2rem;
      border-radius: 10px;
      width: 50vw;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }

    .signup-header {
      text-align: center;
      margin-bottom: 2rem;
      color: var(--text-primary-color);
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .signup-form {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .form-group {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    .form-group label {
      color: #333;
      font-size: 1rem;
    }

    .form-group input {
      padding: 0.75rem;
      border: 1px solid #EEE;
      border-radius: 4px;
      background: white;
      color: #333;
      outline: none;
    }

    .form-group input:focus {
      border-color: #EEE;
    }

    .signup-button {
      background: #414bac;
      color: white;
      padding: 0.75rem;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-weight: 500;
      transition: background-color 0.2s;
    }

    .signup-button:hover {
      background: #363f8f;
    }

    .error-message {
      color: #ff4444;
      font-size: 0.9rem;
      text-align: center;
      margin-top: 1rem;
    }

    .signup-page-container {
      display: flex;
      align-items: center;
      height: 100%;
      width: 100%;
    }
    .signup-banner-container {
      background: #e5e6fb;
      width: 50vw;
      height: 100%;
      position: relative;
      padding: 20px;
      overflow: hidden;
    }

    .signup-banner-logo {
      padding: 30px 20px;
    }

    .signup-container-logo {
      padding: 30px 20px;
      position: absolute;
      top: 0;
      margin:auto;
      display: none;
    }


    .signup-header h2 {
      font-size: 2rem;
      font-weight: 600;
      color: #000;
      margin: 0;
    }

    .signup-header p {
      font-size: 1rem;
      font-weight: 400;
      color: #333333;
      width: 70%;
      text-align: center;
    }
    .signup-banner-text {
      margin-top: 20px;
      z-index: 999;
      padding: 20px;
      position: absolute;
    }
    .signup-banner-text h1 {
      font-size: 2.5rem;
      font-weight: 600;
      color: #414ba6;
      width: 50%;
    }

    .signup-banner-text p {
      font-size: 1.5rem;
      font-weight: 400;
      color: #333333;
      width: 70%;
      line-height: 2rem;
    }

   

    .signup-image-overlay div {
      position: absolute;
      width: 187px;
      height: 187px;
      filter: blur(14px);
      border-radius: 50%;
       background: linear-gradient(225.81deg, #d8dffe 15.93%, #7a90f7 100%);
    
          
    }

    .signup-image-overlay div:first-child {
      top: -52px;
      right: -63px;
    }

    .signup-container-inner {
      
    }

    .signup-image-overlay div:nth-child(2) {
      bottom: -102px;
      left: -103px;
      height: 359px;
      width: 359px;
    }

    .signup-footer {
      text-align: center; 
      font-size: 14px;
    }

    .signup-footer a {
      cursor: pointer;
      text-decoration: underline;
    }

    @media (max-width: 768px) {
   .signup-banner-container {
     display: none;
   }

   .signup-container {
    width: 100%;
    background: #e5e6fb;
   }

   .signup-container-logo {
    display: block;
   }
 }


.profile-image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  margin: 1rem 0;
  position: relative;
  width: 100%;
}

.profile-image-circle {
  width: 128px;
  height: 128px;
  border-radius: 50%;
  border: 2px solid #e2e8f0;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8fafc;
  transition: background-color 0.2s;
}

.profile-image-circle:hover {
  background-color: #f1f5f9;
}

.profile-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.upload-placeholder {
  font-size: 2rem;
}

.pencil-icon {
  position: absolute;
  bottom: 18px;
  right: 18px;
  border-radius: 50%;
  padding: 8px;
}

.upload-text {
  font-size: 0.875rem;
  color: #666;
}
  `,
})
export class Signup {
  @State() username: string = '';
  @State() email: string = '';
  @State() password: string = '';
  @State() errorMessage: string = '';
  @State() isLoading: boolean = false;
  @State() profileImageUrl: string = '';

  @Event() tryLogin: EventEmitter<string>;
  @Event() signupSuccess: EventEmitter<string>;

  private profilePlaceholderImage = 'https://isometrik-website-bucket.s3.ap-south-1.amazonaws.com/Frame_02577f7cb1.svg';

  private profileImageInputRef: HTMLInputElement;

  private handleImageError(e: Event) {
    const img = e.target as HTMLImageElement;
    img.src = this.profilePlaceholderImage;
  }

  private handleSubmit = async (e: Event) => {
    e.preventDefault();

    if (!this.username || !this.email || !this.password || !this.profileImageUrl) {
      this.errorMessage = 'Please fill in all fields';
      return;
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/;
    if (!passwordRegex.test(this.password)) {
      this.errorMessage = 'Password must include one lowercase, one uppercase, and one digit';
      return;
    }

    try {
      this.isLoading = true;
      this.errorMessage = '';

      // Get the file extension
      const fileExtension = this.profileImageUrl.split(';')[0].split('/')[1];

      // Construct the query string
      const queryParams = new URLSearchParams({
        userIdentifier: this.email,
        mediaExtension: fileExtension,
      });

      // Call the API to get the presigned URL with query parameters
      const presignedResponse = await fetch(`${CHAT_CREDS.baseUrl}/chat/user/presignedurl/create?${queryParams.toString()}`, {
        method: 'GET',
        headers: {
          'accept': '*/*',
          'appsecret': `${isometrikFlutterAppSecrets.appSecret}`,
          'content-type': 'application/json',
          'licenseKey': `${isometrikFlutterAppSecrets.licenseKey}`,
          'sec-fetch-mode': 'cors',
          'sec-fetch-site': 'cross-site',
          'usersecret': `${isometrikFlutterAppSecrets.userSecret}`,
        },
      });

      const presignedData = await presignedResponse.json();

      if (!presignedResponse.ok) {
        throw new Error(presignedData.message || 'Failed to get presigned URL');
      }

      // Upload the image to the presigned URL
      const uploadResponse = await fetch(presignedData.presignedUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': `image/${fileExtension}`,
        },
        body: this.profileImageUrl,
      });

      if (!uploadResponse.ok) {
        throw new Error('Failed to upload image');
      }

      const mediaUrl = presignedData.mediaUrl;

      // Call the users.postUser API
      const userResponse = await fetch(`${CHAT_CREDS.baseUrl}/chat/user`, {
        method: 'POST',
        headers: {
          'accept': '*/*',
          'appsecret': `${isometrikFlutterAppSecrets.appSecret}`,
          'content-type': 'application/json',
          'licenseKey': `${isometrikFlutterAppSecrets.licenseKey}`,
          'sec-fetch-mode': 'cors',
          'sec-fetch-site': 'cross-site',
          'usersecret': `${isometrikFlutterAppSecrets.userSecret}`,
        },
        body: JSON.stringify({
          userProfileImageUrl: mediaUrl,
          userName: this.username,
          userIdentifier: this.email,
          password: this.password,
        }),
      });

      const userData = await userResponse.json();

      if (!userResponse.ok) {
        throw new Error(userData.message || 'Signup failed');
      }

      console.log('Signup successful:', userData);

      this.signupSuccess.emit(userData.userToken);

      const webChat = document.querySelector('web-chat');
      const signupPage = document.querySelector('signup-page');

      if (webChat && signupPage) {
        webChat.style.display = 'block';
        // @ts-ignore
        signupPage.style.display = 'none';
      }

      window.location.reload();
    } catch (error) {
      console.error('Signup failed:', error);
      this.errorMessage = 'Signup failed. Please try again.';
    } finally {
      this.isLoading = false;
    }
  };

  private handleImageUpload = (e: Event) => {
    const input = e.target as HTMLInputElement;
    const file = input.files?.[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.profileImageUrl = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  };

  render() {
    return (
      <div class="signup-page-container">
        <div class="signup-banner-container">
          <div class="signup-banner-logo" innerHTML={isometrikLogo}></div>
          <div class="signup-banner-text">
            <h1>"Revolutionizing How You Chat."</h1>
            <p>"Welcome to the future of chatting – simple, fast, and inclusive. Start connecting like never before!"</p>
          </div>
          <img src={onboardingImagePath} alt="signup Page" style={{ width: '68%', height: '52%', position: 'absolute', bottom: '0', right: '0' }} />
          <div class="signup-image-overlay">
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="signup-container">
          <div class="signup-container-logo" innerHTML={isometrikLogo}></div>

          <div class="signup-container-inner">
            <div class="signup-header">
              <h2>Join the Conversation!</h2>
              <p>Create your free account and connect with everyone in just one click!</p>
            </div>

            <form class="signup-form" onSubmit={this.handleSubmit}>
              <div class="form-group">
                <label htmlFor="profileImage">Profile Image</label>
                <div class="profile-image-container">
                  <div
                    class="profile-image-circle"
                    onClick={() => {
                      if (this.profileImageInputRef) {
                        this.profileImageInputRef.click();
                      }
                    }}
                  >
                    {this.profileImageUrl ? (
                      <img src={this.profileImageUrl} alt="Profile" class="profile-image" onError={(e: Event) => this.handleImageError(e)} />
                    ) : (
                      <span class="upload-placeholder">
                        <svg xmlns="http://www.w3.org/2000/svg" height="44px" viewBox="0 -960 960 960" width="44px" fill="#e8eaed">
                          <path d="M440-440ZM120-120q-33 0-56.5-23.5T40-200v-480q0-33 23.5-56.5T120-760h126l74-80h240v80H355l-73 80H120v480h640v-360h80v360q0 33-23.5 56.5T760-120H120Zm640-560v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80ZM440-260q75 0 127.5-52.5T620-440q0-75-52.5-127.5T440-620q-75 0-127.5 52.5T260-440q0 75 52.5 127.5T440-260Zm0-80q-42 0-71-29t-29-71q0-42 29-71t71-29q42 0 71 29t29 71q0 42-29 71t-71 29Z" />
                        </svg>{' '}
                      </span>
                    )}
                  </div>
                  <input
                    type="file"
                    id="profileImage"
                    accept="image/*"
                    ref={el => (this.profileImageInputRef = el as HTMLInputElement)}
                    onChange={(e: Event) => this.handleImageUpload(e)}
                    style={{ display: 'none' }}
                  />
                  <span class="upload-text">Click to upload profile picture</span>
                  {this.profileImageUrl && (
                    <div class="pencil-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed">
                        <path d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z" />
                      </svg>
                    </div>
                  )}
                </div>
              </div>

              <div class="form-group">
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  id="username"
                  value={this.username}
                  onInput={(e: Event) => (this.username = (e.target as HTMLInputElement).value)}
                  placeholder="Enter your username"
                />
              </div>

              <div class="form-group">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" value={this.email} onInput={(e: Event) => (this.email = (e.target as HTMLInputElement).value)} placeholder="Enter your email" />
              </div>

              <div class="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  value={this.password}
                  onInput={(e: Event) => (this.password = (e.target as HTMLInputElement).value)}
                  placeholder="Enter your password"
                />
              </div>

              {this.errorMessage && <div class="error-message">{this.errorMessage}</div>}

              <button type="submit" class="signup-button" disabled={this.isLoading}>
                {this.isLoading ? 'Signing up...' : 'Sign Up'}
              </button>
            </form>
          </div>
          <div class="signup-footer">
            Already have an account? <a onClick={() => this.tryLogin.emit()}>Log In</a>
          </div>
        </div>
      </div>
    );
  }
}
